<template>
  <h3 class="pageFlex" v-if="showAll">
    <span v-if="showLine" :style="{backgroundColor: bgColor}"></span>
    {{val}}
  </h3>
</template>

<script>
export default {
  props: {
    showAll:{
      type:Boolean,
      default:true
    },
    showLine: {
      type: Boolean,
      default: true
    },
    val: String,
    bgColor: {
      type: String,
      default: 'var(--depYelColor)'
    }
  }
};
</script>

<style scoped lang="less">
h3 {
  font-weight: var(--defaultFontWeight);
  font-size: var(--middleFont);
  color: var(--titleColor);
  margin: 14px 0 14px;
  span{
    width: 5px;
    height: 16px;
    margin-right: 8px;
    border-radius: 20px;
  }
}
</style>
